import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  root: {
    height: '579px',
    overflowY: 'auto',
    padding: '10px',
  },
  tableWrap: {
    marginTop: '14px',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  rowActions: {
    width: '90px',
    textAlign: 'right',
  },
  addButtonWrap: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))

export default useStyles
